module.exports = __webpack_public_path__ + "img/40k-giveaway-mobile.e8c42b4.jpg";